import { z } from "zod";
import { sponsorDocumentSchema } from "@event-planner/shared";

/**
 * Admin form schema for the `sponsors` collection.
 *
 * Per ADR-083, the canonical document shape lives in
 * `packages/shared/src/schemas/sponsor.ts`. The form layer adds:
 *  - URL / email validation on the contact fields
 *  - `min(0)` constraint on sortOrder
 *  - Required name
 *
 * `eventId` is set by route param, not edited in the form.
 */
const sponsorDocumentFormBase = sponsorDocumentSchema.omit({
  eventId: true,
});

export const sponsorSchema = z.object({
  ...sponsorDocumentFormBase.shape,
  name: z.string().min(1, "Sponsor name is required"),
  websiteURL: z
    .string()
    .url("Must be a valid URL")
    .nullable()
    .or(z.literal("")),
  contactEmail: z
    .string()
    .email("Must be a valid email")
    .nullable()
    .or(z.literal("")),
  sortOrder: z.number().int().min(0),
});

export type SponsorFormData = z.infer<typeof sponsorSchema>;
